import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createOffer } from "../services/offers";

export function useCreateOffer() {

    const queryClient = useQueryClient();

    const outletUid = localStorage.getItem(

        "selectedOutletUid"

    );

    return useMutation({

        mutationFn: createOffer,

        onSuccess: () => {

            queryClient.invalidateQueries({

                queryKey: [

                    "offers",

                    outletUid,

                ],

            });

        },

    });

}